import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const OPERATIONS_CATEGORIES: SupportCategory[] = [
  { id: 'ops-trainings', label: 'Trainings', departmentId: 'Operations' },
  { id: 'ops-systems', label: 'Systems', departmentId: 'Operations' },
  { id: 'ops-schedules', label: 'Schedules', departmentId: 'Operations' },
  { id: 'ops-room-arrangement', label: 'Room Arrangement', departmentId: 'Operations' },
  { id: 'ops-general', label: 'General Questions', departmentId: 'Operations' },
];

export const OPERATIONS_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'ops-trainings', label: 'Trainings', categoryId: 'ops-trainings' },
  { id: 'ops-systems', label: 'Systems', categoryId: 'ops-systems' },
  { id: 'ops-schedules', label: 'Schedules', categoryId: 'ops-schedules' },
  { id: 'ops-room-arrangement', label: 'Room Arrangement', categoryId: 'ops-room-arrangement' },
  { id: 'ops-general', label: 'General Questions', categoryId: 'ops-general' },
];

export const OPERATIONS_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'ops-trainings-1',
    subcategoryId: 'ops-trainings',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'ops-trainings-2',
    subcategoryId: 'ops-trainings',
    type: 'select',
    label: 'What type of training',
    required: true,
    options: [
      { value: 'Lunch & learn', label: 'Lunch & learn' },
      { value: 'Staff meeting', label: 'Staff meeting' },
      { value: 'Other', label: 'Other' },
    ],
  },
  {
    id: 'ops-trainings-2-other',
    subcategoryId: 'ops-trainings',
    type: 'text',
    label: 'Specify training',
    required: true,
    visibleWhen: { questionId: 'ops-trainings-2', value: 'Other' },
  },
  {
    id: 'ops-trainings-3',
    subcategoryId: 'ops-trainings',
    type: 'text',
    label: 'Topic to be trained on',
    required: true,
  },
  {
    id: 'ops-trainings-4',
    subcategoryId: 'ops-trainings',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'ops-trainings-5',
    subcategoryId: 'ops-trainings',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'ops-trainings-6',
    subcategoryId: 'ops-trainings',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'ops-systems-1',
    subcategoryId: 'ops-systems',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'ops-systems-2',
    subcategoryId: 'ops-systems',
    type: 'text',
    label: 'What system do you need help with',
    required: true,
  },
  {
    id: 'ops-systems-3',
    subcategoryId: 'ops-systems',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'ops-systems-4',
    subcategoryId: 'ops-systems',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'ops-systems-5',
    subcategoryId: 'ops-systems',
    type: 'text',
    label: 'Add any links here',
    required: false,
  },
  {
    id: 'ops-systems-6',
    subcategoryId: 'ops-systems',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'ops-schedules-1',
    subcategoryId: 'ops-schedules',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'ops-schedules-2',
    subcategoryId: 'ops-schedules',
    type: 'select',
    label: 'Which Schedule',
    required: true,
    options: [
      { value: 'Classroom', label: 'Classroom' },
      { value: 'Enrichment', label: 'Enrichment' },
      { value: 'Both', label: 'Both' },
      { value: 'Other', label: 'Other' },
    ],
  },
  {
    id: 'ops-schedules-2-other',
    subcategoryId: 'ops-schedules',
    type: 'text',
    label: 'Specify schedule',
    required: true,
    visibleWhen: { questionId: 'ops-schedules-2', value: 'Other' },
  },
  {
    id: 'ops-schedules-3',
    subcategoryId: 'ops-schedules',
    type: 'text',
    label: 'What needs to be changed',
    required: true,
  },
  {
    id: 'ops-schedules-4',
    subcategoryId: 'ops-schedules',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'ops-schedules-5',
    subcategoryId: 'ops-schedules',
    type: 'date',
    label: 'When do you need this by',
    required: true,
  },
  {
    id: 'ops-schedules-6',
    subcategoryId: 'ops-schedules',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
  {
    id: 'ops-room-1',
    subcategoryId: 'ops-room-arrangement',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'ops-room-2',
    subcategoryId: 'ops-room-arrangement',
    type: 'text',
    label: 'Room Numbers',
    required: true,
  },
  {
    id: 'ops-room-3',
    subcategoryId: 'ops-room-arrangement',
    type: 'text',
    label: 'Age Group',
    required: true,
  },
  {
    id: 'ops-room-4',
    subcategoryId: 'ops-room-arrangement',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'ops-room-5',
    subcategoryId: 'ops-room-arrangement',
    type: 'date',
    label: 'When does this need to be completed by?',
    required: false,
  },
  {
    id: 'ops-room-6',
    subcategoryId: 'ops-room-arrangement',
    type: 'file',
    label: 'Upload photos',
    required: false,
  },
  {
    id: 'ops-general-1',
    subcategoryId: 'ops-general',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'ops-general-2',
    subcategoryId: 'ops-general',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'ops-general-3',
    subcategoryId: 'ops-general',
    type: 'file',
    label: 'Select a file',
    required: false,
  },
];
